import { Dispatch } from "redux";

import _ from "lodash";

import { makeRequest } from "../util";
import {
  FivetranGroup,
  LoadedDestinationInfo,
  LoadedEventDefintion,
} from "../types/global";
import { LOAD_EVENTS, SET_EVENTS_LOADING } from "../reducers/events";
import { SET_DESTINATION_DATA } from "../reducers/destinations";
import { destinationKeyToSlugMap } from "../destinations/destinations";

export const fetchEventDefs = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: SET_EVENTS_LOADING });

    const eventDefsRequest = makeRequest<{
      event_defs: LoadedEventDefintion[];
      dest_info: LoadedDestinationInfo[];
    }>("get_event_defs", {});

    const fivetranLogsRequest = makeRequest<{
      groups: FivetranGroup[];
    }>("fivetran_groups", {});

    const [eventDefResponse, fivetranLogsResponse] = await Promise.all([
      eventDefsRequest,
      fivetranLogsRequest,
    ]);

    const getFivetranGroup = (destID: string) => {
      const group = fivetranLogsResponse.data.groups.find(
        ({ destinationID }) => destinationID === destID
      );
      return group ? group.groupID : undefined;
    };

    dispatch({
      type: LOAD_EVENTS,
      payload: _.sortBy(eventDefResponse.data.event_defs, (eventDef) =>
        eventDef.name.toLowerCase()
      ),
    });

    dispatch({
      type: SET_DESTINATION_DATA,
      payload: Object.fromEntries(
        eventDefResponse.data.dest_info.map((dest: LoadedDestinationInfo) => [
          destinationKeyToSlugMap[dest.name],
          { ...dest, fivetran_group_id: getFivetranGroup(dest.id) },
        ])
      ),
    });
  };
};
